export class BonusGameEvents {
	public static readonly BONUS_GAME_STARTED: string = 'BonusGameEvents::__BONUS_GAME_STARTED__';
	public static readonly BONUS_GAME_FINISHED: string = 'BonusGameEvents::__BONUS_GAME_FINISHED__';

	public static readonly BONUS_INTRO_STARTED: string = 'BonusGameEvents::__BONUS_INTRO_STARTED__';
	public static readonly BONUS_INTRO_FINISHED: string = 'BonusGameEvents::__BONUS_INTRO_FINISHED__';

	public static readonly BONUS_OUTRO_STARTED: string = 'BonusGameEvents::__BONUS_OUTRO_STARTED__';
	public static readonly BONUS_OUTRO_FINISHED: string = 'BonusGameEvents::__BONUS_OUTRO_FINISHED__';

	public static readonly PICK: string = 'BonusGameEvents::__PICK__';

	public static readonly WIN_RESULT_SHOWN: string = 'BonusGameEvents::WIN_RESULT_SHOWN';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/bonus/BonusGameEvents.ts